// features/table/tasksTableSlice.js
import { generateInitialState, createTableSlice } from './tableSlice';

const tasksTableInitialState = generateInitialState('dueDate', 'desc');
export const tasksTableSlice = createTableSlice('taskTable', tasksTableInitialState);

export const {
	setPageAfter,
	setRowsPerPage,
	setOpenDialog,
	setSearchValue,
	setSearchText,
	setOrderBy,
	setOrder,
	setPage,
	setRows,
	resetSearchFields,
	changeRowsPerPage,
	requestSort,
	changePage,
	resetAllPages,
	onOrderChange,
	setSelected,
	triggerRefresh,
} = tasksTableSlice.actions;

export default tasksTableSlice.reducer;
